module.exports = __webpack_public_path__ + "img/project18_5.png.62c01032.webp";